import {
  initializeWidgetConfiguration,
  SgWidget,
  WidgetConfigurationProvider,
  WithGlobalCss,
} from "@sgwt-widget/core";
import { h } from "preact";
import { emit, props } from "skatejs";
import { ExportColumnsSelector } from "./components/ExportColumnsSelector";

// tslint:disable-next-line:interface-name
interface IProps {
  widgetidentifier: string;
  userSelection: { columns: string[] };
}

class CprSelectExportColumns extends SgWidget<IProps> {
  public static is = "cpr-select-export-columns";

  public static props = {
    userSelection: props.object,
    widgetidentifier: props.string,
  };

  // tslint:disable-next-line:no-shadowed-variable
  public render(intraprops: IProps) {
    const widgetidentifier = intraprops.widgetidentifier || "";
    let userSelection =
      intraprops.userSelection && intraprops.userSelection.columns
        ? intraprops.userSelection.columns.map(x => x.replace("+", " "))
        : [];
    if (userSelection.length === 1 && userSelection[0].length === 0) {
      userSelection = [];
    }
    const onChange = (value: string[]) => {
      const newValue =
        value && value.length > 0 ? { columns: value } : { columns: [] };
      intraprops.userSelection = newValue;
      emit(this, "cpr-select-export-columns--filter-changed", {
        detail: newValue,
      });
    };

    return (
      <WidgetConfigurationProvider
        widgetConfiguration={this.widgetConfiguration}
      >
        <WithGlobalCss>
          <ExportColumnsSelector
            onChange={onChange}
            board={widgetidentifier}
            exportColumns={userSelection}
          />
        </WithGlobalCss>
      </WidgetConfigurationProvider>
    );
  }
}

initializeWidgetConfiguration(CprSelectExportColumns, {
  neverUseShadowDOM: true,
});
customElements.define(CprSelectExportColumns.is, CprSelectExportColumns);
